/** @jsxImportSource @emotion/react */
import React, { ReactElement } from "react";

import { css } from "@emotion/react";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import ErrorPage from "Components/ErrorPage";

export default function TimedOut(): ReactElement {
  function handleSignIn() {
    window.location.href = "/login";
  }

  return (
    <ErrorPage title="Timed out">
      <Typography variant="body1">
        For security, you&apos;ve been signed out due to inactivity. Access your session again to continue from where
        you left off.
      </Typography>
      <Button
        css={css`
          display: block;
          margin: 32px auto 0;
        `}
        color="primary"
        variant="contained"
        size="large"
        onClick={handleSignIn}
      >
        Sign In
      </Button>
    </ErrorPage>
  );
}
